module.exports = __webpack_public_path__ + "static/media/icons.4cacd99f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/icons.svg
// module id = 382
// module chunks = 37